import { render, staticRenderFns } from "./InstantLinkApi.vue?vue&type=template&id=1bef4b25&scoped=true&"
import script from "./InstantLinkApi.vue?vue&type=script&lang=js&"
export * from "./InstantLinkApi.vue?vue&type=script&lang=js&"
import style0 from "./InstantLinkApi.vue?vue&type=style&index=0&id=1bef4b25&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bef4b25",
  null
  
)

export default component.exports